/**
 * @generated SignedSource<<44df4003018229ca9a2dd8bd4208cb08>>
 * @relayHash 7f786b1b32fc2ce163b24899322261c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f53ac5ff6d0659ed0b388d8e3f5fdb54c22ce66a19585c73ea4148d41b5de42b

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type settingsSidebarPermissionQuery$variables = {
  cloudId: string;
};
export type settingsSidebarPermissionQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"PageSwitcherWithQuery_jira" | "SidebarHeading_jira">;
  } | null;
};
export type settingsSidebarPermissionQuery = {
  response: settingsSidebarPermissionQuery$data;
  variables: settingsSidebarPermissionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "settingsSidebarPermissionQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PageSwitcherWithQuery_jira"
          },
          {
            "kind": "FragmentSpread",
            "name": "SidebarHeading_jira"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "settingsSidebarPermissionQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              }
            ],
            "kind": "ScalarField",
            "name": "hasJsmAdminAccess"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f53ac5ff6d0659ed0b388d8e3f5fdb54c22ce66a19585c73ea4148d41b5de42b",
    "metadata": {},
    "name": "settingsSidebarPermissionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c40751421e2a2b6491be3bfe1825b577";

export default node;
